import React from 'react';
import { useSurvey } from './SurveyContext';
import { FooterProps } from './types';
import QuestLabs from '../../../../components/QuestLabs';


export const Footer: React.FC<FooterProps> = ({ 
  showFooter = true,
  className
}) => {
  const { themeManager } = useSurvey();

  if (!showFooter) return null;

  return (
    <div className={`q-survey-footer ${className || ''}`}>
      <QuestLabs style={themeManager.getFooterStyles()} />
    </div>
  );
};